import { useIntl } from "react-intl";
import { useQuery } from "react-query";

import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import {
  CorporateEntity,
  ListRequestOfBaseFilter,
  ListResponseOfCorporateEntity,
} from "services/KnowfullyAdminClient";

type SelectCorporateEntityProps = Omit<
  AutocompleteWithQueryProps<CorporateEntity>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectCorporateEntity = (props: SelectCorporateEntityProps) => {
  const { formatMessage: t } = useIntl();
  const { catalogService } = useGlobalContext();

  const fetchedCorporateEntities = useQuery<ListResponseOfCorporateEntity>(
    ["corporateEntities"],
    () =>
      catalogService.getCorporateEntities(
        ListRequestOfBaseFilter.fromJS({
          sortField: "name",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...props}
      labelField="name"
      fetchedData={fetchedCorporateEntities}
      failMessage={t({ id: "selectCorporateEntityFetchFailed" })}
    />
  );
};

export default SelectCorporateEntity;
